// IMPORTANT!
// Add report type to this list if the corresponding
// form does not have a user submitted "name" field.

import {ReportTypesEnum} from 'common/proxies/enum-proxy';

export const cardsWithoutNameInputs = [
  ReportTypesEnum.BUILDING_INFO || {},
  ReportTypesEnum.TENANT_INFO || {},
  ReportTypesEnum.IMAGE || {},
  ReportTypesEnum.TEXT || {},
  ReportTypesEnum.IFRAME || {},
]
  .map((enums) => enums.id)
  .filter((x) => x);
